import { render, staticRenderFns } from "./ImportVipssStudent.vue?vue&type=template&id=7b828e34&scoped=true&"
import script from "./ImportVipssStudent.vue?vue&type=script&lang=js&"
export * from "./ImportVipssStudent.vue?vue&type=script&lang=js&"
import style0 from "./ImportVipssStudent.vue?vue&type=style&index=0&id=7b828e34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b828e34",
  null
  
)

export default component.exports